import React from 'react';
import styled from 'styled-components';
import { SlideContainer } from './container';
import { SlideContent } from './content';
import { Text } from './text';
import { Highlight } from './highlight';
import { SlideProps } from '../Recap';
import RecapSlide from '../RecapSlide';
import { asset } from '../../../utils/misc';

const primaryColor = '#48a62c';
const secondaryColor = '#115000';

const SeatImageContainer = styled.div`
    .seat-img {
        z-index: 100;
        position: absolute;
        top: -50px;
        right: -110px;
        width: 120px;

        &:first-child {
            z-index: 101;
        }
    }
`;

export const Slide2 = ({ current = false, scale, data, soundEnabled = false }: SlideProps) => {
    const musicUrl = asset('/dist/audio/recap-music-02.mp3');
    const soundUrl = asset('/dist/audio/pop-01.mp3');
    const sizeFactor = 1.3;

    return (
        <RecapSlide animations={[
            ['line-1', 'line-2', 'line-7'],
            ['line-3'],
            ['line-4'],
            ['line-5'],
            ['line-6'],
        ]} focus={current} soundEnabled={soundEnabled} musicUrl={musicUrl} soundUrl={soundUrl} playSoundOnce={true}>
            <SlideContainer>
                <SlideContent bg={secondaryColor} scale={scale}>
                    <Text fontFamily='fifties-cond-med' fontSize={`${60 * sizeFactor}px`} color={primaryColor} lineHeight='1' className="line-1 overflow-h">
                        <span className="anim anim-slide-from-top">Viste</span>
                    </Text>

                    <div style={{ position: 'relative' }}>
                        <Highlight bg={primaryColor} color={secondaryColor} className="overflow-h box anim anim-fade-in line-2" style={{ marginBottom: '10px', paddingRight: '30px' }}>
                            <span className="anim anim-fade-in" style={{ fontSize: `${60 * sizeFactor}px`, marginRight: `${8 * sizeFactor}px` }}>
                                {data && data.movies_watched}
                            </span>
                            <span className="anim anim-slide-from-left anim-fade-in" style={{ fontSize: `${33 * sizeFactor}px`, transform: "translateX(-250%)" }}>pelis</span>
                        </Highlight>

                        <SeatImageContainer className='line-7'>
                            <img src={asset('/dist/images/year-recap/seat.png')} className="seat-img anim anim-scale-in anim-fade-in" />
                            <img src={asset('/dist/images/year-recap/seat-lights.png')} className="seat-img anim anim-scale-in anim-fade-in" />
                        </SeatImageContainer>
                    </div>

                    <Highlight bg={primaryColor} color={secondaryColor} fontSize={`${30 * sizeFactor}px`} className="overflow-h box anim anim-fade-in line-3" style={{
                        marginBottom: `${10 * sizeFactor}px`,
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <span className="anim anim-slide-from-above" style={{ fontSize: `${60 * sizeFactor}px`, marginRight: `${8 * sizeFactor}px`, transform: "translateY(-250%)" }}>
                            {data && data.hours_spent}
                        </span>
                        <span className="anim anim-fade-in" style={{ lineHeight: 0.8 }}>
                            horas<br />
                            de emoción
                        </span>
                    </Highlight>

                    <Text fontFamily='fifties-cond-med' color={primaryColor} fontSize={`${43 * sizeFactor}px`} className="overflow-h wait line-4">
                        <span className="anim anim-slide-from-above">y</span>
                        {' '}
                        <span className="anim anim-slide-from-top">tu</span>
                        {' '}
                        <span className="anim anim-slide-from-top">género</span>
                    </Text>
                    <Text fontFamily='fifties-cond-med' color={primaryColor} fontSize={`${54 * sizeFactor}px`} className="overflow-h line-5">
                        <span className="anim anim-slide-from-top">favorito</span>
                        {' '}
                        <span className="anim anim-slide-from-top">es</span>
                    </Text>
                    <Highlight bg={primaryColor} color={secondaryColor} fontSize={`${60 * sizeFactor}px`} className="line-6 box anim anim-fade-in">
                        <span className="anim anim-fade-in">{data && data.fav_genre}</span>
                    </Highlight>
                </SlideContent>
            </SlideContainer>
        </RecapSlide>
    );
};